<template>
    <div class="down-container">
        <van-nav-bar
            :title="dataObj.title"
            left-text="返回"
            left-arrow
            @click-left="$router.back()"
        />

        <div class="box-content">
            <div class="tool">
                <div class="pic" :style="`background-image: url(${dataObj.pic})`"></div>
                <div class="info">
                    <span class="title">{{ dataObj.title }}</span>
                    <span class="num">{{ dataObj.num }}次下载</span>
                    <a :href="dataObj.url" class="download">极速下载</a>
                </div>
                <div class="qrcode" ref="qrCodeUrl"></div>
            </div>
            <div class="dt">
                <span class="dt-title">应用描述</span>
            </div>
            <span class="details">{{ dataObj.details }}</span>

            <div class="hot-tool">
                <Tools :dataList="hotList" :dtitle="'推荐应用'"></Tools>
            </div>
        </div>
    </div>
</template>

<script>
import Tools from "@/components/tools.vue";
// 二维码生成
import QRCode from 'qrcodejs2'

export default {
    components: {
        Tools,
    },
    data() {
        return {
            dataObj: {
                pic: '',
                title: '应用详情',
                num: 0,
                url: '',
                details: '暂无描述'
            },
            hotList: [],
        };
    },
    methods: {
        // 二维码
        creatQrCode() {
            this.$refs.qrCodeUrl.innerHTML = ""//词句代码将之前的二维码清空了
            var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: this.dataObj.url, // 需要转换为二维码的内容
                width: 80,
                height: 80,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
        },
        // 热门推荐
        async getHotList() {
            const { data: res } = await this.$http.get('/list')
            let arr = res.data
            let randomArr = arr.sort(() => Math.random()-0.5) // 生成随机数组
            this.hotList = randomArr.slice(0,4) // 截取数组
        },
    },
    mounted() {
        this.creatQrCode();
    },
    created() {
        try {
            const cache = localStorage.getItem("rowData")
            const parsed = cache ? JSON.parse(cache) : null
            if (parsed && typeof parsed === 'object') {
                this.dataObj = {
                    ...this.dataObj,
                    ...parsed
                }
            }
        } catch (error) {
            // 忽略解析失败并使用默认值
        }
        this.getHotList()
    },
};
</script>

<style lang="less" scoped>
.box-content {
    padding: .7rem .1rem .3rem;
    background: transparent;
    .dt {
        display: flex;
        align-items: center;
        padding: .6rem 0;
        .dt-title {
            font-size: 1.02rem;
            color: #1a3260;
            font-weight: 800;
            letter-spacing: 1px;
            margin-left: .5rem;
        }
        &::before {
            content: "";
            display: block;
            width: .8rem;
            height: .8rem;
            border-radius: 50%;
            background: linear-gradient(135deg, #116dff, #00b3a7);
        }
    }
    .details {
        color: #60718f;
        font-size: .92rem;
        line-height: 1.65;
    }
}

.tool {
    position: relative;
    min-height: 9rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: .9rem;
    border-radius: 1rem;
    border: 1px solid rgba(17, 109, 255, .15);
    background: var(--a-surface);
    box-shadow: var(--a-shadow);
    .pic {
        width: 7rem;
        height: 7rem;
        background-size: cover;
        border-radius: .95rem;
        background-position: center;
        overflow: hidden;
    }
    .info {
        flex: 1;
        min-height: 7rem;
        padding-left: .85rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
            font-size: 1.2rem;
            font-weight: 800;
            color: #1f3152;
        }
        .num {
            color: #116dff;
            font-size: .86rem;
            font-weight: 700;
        }
        .details {
            width: 15rem;
            font-size: 1rem;
            color: #909090;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .download {
            width: 8rem;
            height: 2.3rem;
            background: linear-gradient(120deg, #116dff, #00b3a7);
            border-radius: 2.5rem;
            color: #fff;
            font-size: .9rem;
            font-weight: 700;
            text-align: center;
            line-height: 2.3rem;
            cursor: pointer;
            box-shadow: 0 8px 14px rgba(17, 109, 255, .24);
        }
    }

    .qrcode {
        background: #fff;
        border-radius: .7rem;
        padding: .35rem;
        border: 1px solid rgba(17, 109, 255, .16);
    }
}
.hot-tool {
    margin-top: 2rem;
}

/deep/ .van-nav-bar {
    border-radius: .95rem;
    overflow: hidden;
    box-shadow: var(--a-shadow);
    margin-bottom: .8rem;
}
</style>